export function HouseIcon({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M100,18 L172,82 L172,177 L124,177 L124,110 L76,110 L76,177 L28,177 L28,82 Z"
        fill="currentColor"
      />
    </svg>
  );
}
